import request from "@/utils/request";

const obj = {
  agentGetCarportById(params) {
    return request.get(`/device/carport/agentGetCarportById`, {
      params,
    });
  },
  searchCarportByName(params) {
    return request.get(`/device/carport/agent/searchCarportByName`, {
      params,
    });
  },
  agentGetAllCarport() {
    return request.get(`/device/carport/agentGetAllCarport`);
  },
  agentEditCarport(data) {
    return request.post(`/device/carport/agentEditCarport`, data);
  },
  agentAddCarTypeOfCarport(data) {
    return request.post(
      `/device/carTypeOfCarport/agentAddCarTypeOfCarport`,
      data
    );
  },
};
export default obj;
